export default "__VITE_ASSET__BPUGlBQK__"